import { CheckableGroupComponent } from "./chunk-CPCZVPXA.js";
import { __objRest, __spreadValues } from "./chunk-ORMEWXMH.js";

// src/components/CheckboxGroup/CheckboxGroup.tsx
import React from "react";
import clsx from "clsx";
var CheckboxGroup = _a => {
  var _b = _a,
    {
      children,
      className
    } = _b,
    rest = __objRest(_b, ["children", "className"]);
  return /* @__PURE__ */React.createElement(CheckableGroupComponent, __spreadValues({
    className: clsx("pd-checkbox-group", className)
  }, rest), /* @__PURE__ */React.createElement(CheckableGroupComponent.Fields, {
    className: "pd-checkbox-group__fields"
  }, children));
};
var CheckboxGroup_default = CheckboxGroup;
export { CheckboxGroup_default };